import {HttpClientModule} from '@angular/common/http';
import {CanAccessGuard} from './guards/can-access.guard';
import {NeoUserService} from './services/neo-user/neo-user.service';
import {NeoPrivateService} from './services/neo-private/neo-private.service';
import {NeoPaymentService} from './services/neo-payment/neo-payment.service';
import {NeoOrderService} from './services/neo-order/neo-order.service';
import {NeoRestService} from './services/neo-rest/neo-rest.service';
import {NeoNotesService} from './services/neo-note/neo-note.service';
import {NeoInventoryService} from './services/neo-inventory/neo-inventory.service';
import {NeoInitLangService} from './services/neo-init/neo-init-lang.service';
import {NeoHotelService} from './services/neo-hotel/neo-hotel.service';
import {NeoExtraService} from './services/neo-extra/neo-extra.service';
import {NeoJWTService} from "./services/neo-jwt/neo-jwt";
import {NeoBasketService} from './services/neo-basket/neo-basket.service';
import {NeoStorageService, NeoGlobalService, NeoLangService} from 'ng-neo';
import {NeoAvailService} from './services/neo-avail/neo-avail.service';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Ng2ImgFallbackModule} from 'ng2-img-fallback';


import {JsonApiService} from './api/json-api.service';
import {VoiceControlService} from '../shared/voice-control/voice-control.service'
import {SoundService} from "../shared/sound/sound.service";


import {throwIfAlreadyLoaded} from './guards/module-import-guard';
import {VoiceRecognitionService} from "../shared/voice-control/voice-recognition.service";
import {
    TabsModule, ProgressbarModule, TooltipModule, BsDropdownModule, AlertModule,
    PopoverModule
} from "ngx-bootstrap";
import {NeoClientService} from "./services/neo-client/neo-client.service";
import {LayoutService} from "../shared/layout";
import {UserService} from "../shared/user";
import {NeoChainService} from "./services/neo-chain/neo-chain.service";
import {NeoConfigStepsService} from "./services/neo-configsteps/neo-configsteps.service";
import {NeoTranslationService} from "./services/neo-translations/neo-translations.service";
import {NeoOfflineService} from "./services/neo-offline/neo-offline.service";
import {NeoHistoryService} from "./services/neo-history/neo-history";
import {NeoACLService} from "./services/neo-acl/neo-acl";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,

        Ng2ImgFallbackModule,

        TooltipModule.forRoot(),
        BsDropdownModule.forRoot(),
        ProgressbarModule.forRoot(),
        AlertModule.forRoot(),
        TabsModule.forRoot(),
        PopoverModule.forRoot()
    ],
    declarations: [],
    exports: [
        HttpClientModule
    ],
    providers: [
        JsonApiService,
        LayoutService,
        UserService,
        VoiceControlService,
        VoiceRecognitionService,
        SoundService,

        // NeoServices
        NeoAvailService,
        NeoStorageService,
        NeoBasketService,
        NeoExtraService,
        NeoGlobalService,
        NeoHotelService,
        NeoInitLangService,
        NeoInventoryService,
        NeoLangService,
        NeoNotesService,
        NeoRestService,
        NeoOrderService,
        NeoPaymentService,
        NeoClientService,
        NeoPrivateService,
        NeoUserService,
        NeoJWTService,
        NeoChainService,
        NeoConfigStepsService,
        NeoTranslationService,
        NeoOfflineService,
        NeoHistoryService,
        NeoACLService,

        // Guards
        CanAccessGuard
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts